<template lang="pug">
div
  User
  div
    // Header
    el-main
      router-view
</template>

<script>
import Header from './Header'
import User from './user'
export default { name: 'cart', components: { Header, User } }
</script>
